import React, { Component } from "react";
import Swiper from "swiper";

import VacancyGridItem from "components/Vacancy/VacancyGrid/VacancyGridItem";

export default class VacancyGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vacatures: [],
      loading: true
    };
  }
  async componentDidMount() {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}vacatures/v1/overview`
    );
    let vacatures = await res.json();
    this.setState({ vacatures: vacatures });

    new Swiper(".vacancyGrid", {
      speed: 400,
      slidesPerView: "auto",
      preloadImages: true,
      lazy: true,
      watchSlidesVisibility: true,
      slideClass: "vacancyGridItem",
      allowTouchMove: false,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      on: {
        init: function() {
          if (window.innerWidth >= 1024) {
            this.allowTouchMove = false;
          } else {
            this.allowTouchMove = true;
            this.slideTo(0);
          }
          this.update();
        },
        resize: function() {
          if (window.innerWidth >= 1024) {
            this.allowTouchMove = false;
          } else {
            this.allowTouchMove = true;
            this.slideTo(0);
          }
          this.update();
        }
      }
    });
  }

  renderVacature(vacature, i) {
    return <VacancyGridItem
      vacancyImage={vacature.thumbnail}
      vacancyTitle={vacature.title}
      vacancySubText={vacature.summary}
      vacancyHref={vacature.slug} />;
  }

  render() {
    const { vacatures } = this.state;
    const currentState = this;

    return (
      <div
        className={
          "vacancyGrid swiper-container__vacancy" +
          (this.props.extraClasses ? " " + this.props.extraClasses : "")
        }
      >
        <div className="swiper-wrapper">
          {vacatures.map(function(vacature, i) {
            return currentState.renderVacature(vacature, i);
          })}
        </div>
        <div className="swiper-button-container">
          <div className="swiper-button-prev">
            <span />
            <span />
            <span />
          </div>
          <div className="swiper-button-next">
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Vacancy/VacancyGrid/VacancyGrid.jsx